export default __webpack_public_path__ + "static/media/emoji-done.595b795a.svg";